module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/094-south-korea-6db0530f8f3dec130b9235a6a15d8e61.svg";